import { useEffect, useLayoutEffect, useState } from "react";
import Cookies from "universal-cookie";
import { useToExpandFooter } from "../../hooks/useToExpandFooter";
import ReactDOM from "react-dom";
import { CloseButton } from "./CloseButton";
import { ArrowWithLabelHint } from "./ArrowWithLabelHint";
import { ImgStyled, useClasses } from "./OnScreenHelp.style";
import { Box } from "@mui/material";
import clsx from "clsx";

const HIDE_COOKIE_NAME = "app-hints-hide_20250224";
const HIDE_ALL_COOKIE_NAME = "app-hints-hideall_20250224";

interface Item {
  indicatorCssProps: React.CSSProperties;
  hintCssProps: React.CSSProperties;
  arrowCssProps: React.CSSProperties;
  arrowLocation: "start" | "end";
  arrowPosition: "left" | "right" | "center";
  text?: string;
  labelId?: string;
  padding: number;
  key: string;
  arrowWidth?: number;
  arrowHeight?: number;
  compact?: boolean;
  isHTML?: boolean;
}

const handlePreventDefault = (event: any) => {
  event.preventDefault();
};

const OnScreenHelp: React.FC<{
  config: OnScreenHelpConfig;
  onClose?: (items: OnScreenHelpConfigItem[]) => void;
  closeButtonLabel?: string;
}> = ({ config, onClose, closeButtonLabel }) => {
  const isToExpand = useToExpandFooter();

  const classes = useClasses();

  var overlayItemStyle: React.CSSProperties = {
    borderRadius: "4px",
    position: "fixed",
    backgroundColor: "#ffffff",
    opacity: 0.4,
    pointerEvents: "auto",
    transition: "opacity 0.2s ease 0s",
    zIndex: 10000001,
  };

  var hintCssStyle: React.CSSProperties = {
    position: "fixed",
    width: "200px",
    display: "flex",
    flexDirection: "column",
    color: "#FFFFFF",
    alignItems: "center",
    zIndex: 10000001,
    textAlign: "unset"
  };

  const [items, setItems] = useState<undefined | Item[]>(undefined);
  const [open, setOpen] = useState<boolean>(false);
  const [windowSize, setWindowSize] = useState([0, 0]);

  useEffect(() => {
    const cookies = new Cookies();
    var hideAll = cookies.get(HIDE_ALL_COOKIE_NAME);
    if (hideAll !== undefined && hideAll === true) return;

    var hideSingle = cookies.get(HIDE_COOKIE_NAME);
    if (
      hideSingle !== undefined &&
      (hideSingle as string).indexOf("|" + config.id) !== -1
    )
      return;

    setTimeout(
      () => {
        var myitemList = config.items;
        var itemList = config.items
          .filter((x, index) => {
            var element = document.getElementsByClassName(x.className);
            if (element.length === 0) return false;
            return true;
          })
          .map((x, index) => {
            var padding = x.padding === undefined ? 10 : x.padding;
            var element = document.getElementsByClassName(x.className);
            if (x.disableScroll === undefined || x.disableScroll === false)
              element[0].scrollIntoView({
                /*behavior: "smooth",*/ block: "end",
              });
            var bounds2 = element[0].getBoundingClientRect();
            var bounds = {
              top: bounds2.top,
              left: bounds2.left,
              bottom: bounds2.bottom,
              right: bounds2.right,
              width: bounds2.width,
              height: bounds2.height,
            };
            bounds.top =
              bounds.top +
              (element[0].ownerDocument.defaultView?.pageYOffset ?? 0);
            bounds.left =
              bounds.left +
              (element[0].ownerDocument.defaultView?.pageXOffset ?? 0);
            bounds.bottom =
              bounds.bottom +
              (element[0].ownerDocument.defaultView?.pageYOffset ?? 0);
            bounds.right =
              bounds.right +
              (element[0].ownerDocument.defaultView?.pageXOffset ?? 0);
            //console.log(bounds);
            //console.log(element[0].ownerDocument.defaultView?.pageYOffset);
            var result: any = {
              key: config.id + "_" + index,
              text: x.text,
              labelId: x.labelId,
              padding: padding,
              isHTML: x.isHTML,
              indicatorCssProps: {
                ...overlayItemStyle,
                top: bounds.top - padding + "px",
                left: bounds.left - padding + "px",
                bottom: window.innerHeight - bounds.bottom - padding + "px",
                right: window.innerWidth - bounds.right - padding + "px",
              },
              hintCssProps: {
                ...hintCssStyle,
              } as React.CSSProperties,
              arrowCssProps: {} as React.CSSProperties,
            };
            if (x.vertical == "center") {
              result.hintCssProps.flexDirection = "row";
              result.hintCssProps.top =
                bounds.top + bounds.height / 2 - x.height / 2;
              result.hintCssProps.height = x.height + "px";
              result.arrowPosition = "center";
              if (x.horizontal == "left") {
                result.arrowLocation = "end";
                result.hintCssProps.right =
                  bounds.left + bounds.width + padding + "px";
                result.arrowCssProps.transform = "rotate(90deg)";
                result.arrowCssProps.marginRight = "5px";
                result.arrowCssProps.marginLeft = "5px";
              } else if (x.horizontal == "right") {
                result.arrowLocation = "start";
                result.hintCssProps.left = bounds.right + padding + "px";
                result.arrowCssProps.transform = "rotate(270deg)";
                result.arrowCssProps.marginRight = "5px";
                result.arrowCssProps.marginLeft = "5px";
              } else {
                throw "error";
              }
            } else {
              if (x.vertical === "bottom") {
                result.hintCssProps.top = bounds.bottom + padding + "px";
                result.arrowLocation = "start";
              }
              if (x.vertical === "top") {
                result.hintCssProps.bottom =
                  window.innerHeight -
                  bounds.bottom +
                  bounds.height +
                  padding +
                  "px";
                result.arrowLocation = "end";
                result.arrowCssProps.transform = "rotate(180deg)";
              }
              if (x.horizontal === "right") {
                result.hintCssProps.alignItems = "flex-end";
                result.arrowPosition = "right";
                result.hintCssProps.right =
                  window.innerWidth - bounds.right - padding + "px";
              }
              if (x.horizontal === "left") {
                result.hintCssProps.alignItems = "flex-start";
                result.arrowPosition = "left";
                result.hintCssProps.left = bounds.left - padding + "px";
              }

              if (x.horizontal === "center") {
                result.arrowPosition = "center";
                result.hintCssProps.left =
                  bounds.left + bounds.width / 2 - x.width / 2 + "px";
              }

              result.hintCssProps.width = x.width + "px";
            }

            if (result && result.hintCssProps) {
              if (
                result.hintCssProps.left &&
                result.hintCssProps.left.startsWith("-")
              )
                result.hintCssProps.left = "5px";
              if (
                result.hintCssProps.right &&
                result.hintCssProps.right.startsWith("-")
              )
                result.hintCssProps.right = "5px";
            }

            if (x.arrowHeight) result.arrowHeight = x.arrowHeight;
            if (x.arrowWidth) result.arrowWidth = x.arrowWidth;

            if (x.compact) result.compact = x.compact;

            return result;
          });

        if (itemList.length > 0) {
          setItems(itemList);
          setOpen(true);

          document.body.addEventListener("touchmove", handlePreventDefault, {
            passive: false,
          });
        }
      },
      config.timeout !== undefined ? config.timeout : 500
    );
  }, [windowSize, config]);

  useLayoutEffect(() => {
    function updateSize() {
      setWindowSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const handleClose = (closeForGood: boolean) => {
    document.body.removeEventListener("touchmove", handlePreventDefault);

    const cookies = new Cookies();
    if (closeForGood) {
      cookies.set(HIDE_ALL_COOKIE_NAME, "true", {
        path: "/",
        expires: new Date(2050, 11),
        sameSite:
          process.env.REACT_APP_SECURED_COOKIES &&
          process.env.REACT_APP_SECURED_COOKIES === "true"
            ? "none"
            : undefined,
        secure:
          process.env.REACT_APP_SECURED_COOKIES &&
          process.env.REACT_APP_SECURED_COOKIES === "true"
            ? true
            : undefined,
      });
    } else {
      var hideSingle = cookies.get(HIDE_COOKIE_NAME);
      if (
        hideSingle === undefined ||
        (hideSingle as string).indexOf("|" + config.id) == -1
      ) {
        if (hideSingle === undefined) hideSingle = "";
        hideSingle += "|" + config.id;
        cookies.set(HIDE_COOKIE_NAME, hideSingle, {
          path: "/",
          expires: new Date(2050, 11),
          sameSite:
            process.env.REACT_APP_SECURED_COOKIES &&
            process.env.REACT_APP_SECURED_COOKIES === "true"
              ? "none"
              : undefined,
          secure:
            process.env.REACT_APP_SECURED_COOKIES &&
            process.env.REACT_APP_SECURED_COOKIES === "true"
              ? true
              : undefined,
        });
      }
    }
    setOpen(false);
    if (onClose) onClose(config.items);
  };

  if (items === undefined || open === false) return <></>;

  return ReactDOM.createPortal(
    <>
      <Box sx={classes.overlayStyle} className={" on-screen-help-overlay"}>
        {items.map((x, index) => {
          return (
            <div
              className={clsx(
                "on-screen-help-overlay-item",
                classes.onScreenHelpOverlayItem
              )}
              style={x.indicatorCssProps}
              key={"hint_indicator_" + x.key}
            ></div>
          );
        })}
      </Box>
      {items.map((x, index) => {
        return (
          <div
            className={"on-screen-help-overlay-item-hint-container"}
            style={x.hintCssProps}
            key={"hint_" + x.key}
          >
            {x.arrowLocation === "start" && (
              <ImgStyled
                src={config.arrowIcon}
                width={x.arrowWidth ?? 50}
                height={x.arrowHeight ?? 50}
                style={x.arrowCssProps}
                alt=""
              ></ImgStyled>
            )}

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "calc(100% + 100px)",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <ArrowWithLabelHint config={config} x={x}></ArrowWithLabelHint>
              </div>
              {/*index === 0 && (
                  <CloseButton
                    config={config}
                    classes={classes}
                    isToExpand={isToExpand}
                    handleClose={handleClose}
                    closeButtonLabel={closeButtonLabel}
                  ></CloseButton>
                )*/}
            </div>

            {x.arrowLocation === "end" && (
              <ImgStyled
                alt=""
                src={config.arrowIcon}
                width={x.arrowWidth ?? 50}
                height={x.arrowHeight ?? 50}
                style={x.arrowCssProps}
              ></ImgStyled>
            )}
          </div>
        );
      })}
      {
        /*!isDesktop &&*/ <CloseButton
          config={config}
          isToExpand={isToExpand}
          handleClose={handleClose}
          closeButtonLabel={closeButtonLabel}
        ></CloseButton>
      }
    </>,
    document.body
  );
};

export const OnScreenHelpMultiStep: React.FC<{
  config: OnScreenHelpConfig;
}> = ({ config }) => {
  const [currentStepIndex, setCurrentStepIndex] = useState<number>(0);

  const getItemsToShow: (
    items: OnScreenHelpConfigItem[]
  ) => OnScreenHelpConfigItem[] = (items: OnScreenHelpConfigItem[]) => {
    const cookies = new Cookies();
    const hideAll = cookies.get(HIDE_ALL_COOKIE_NAME);
    if (hideAll !== undefined && hideAll === true) return [];

    const hideSingle = cookies.get(HIDE_COOKIE_NAME);
    return items.filter((x) => {
      return (
        hideSingle === undefined ||
        (hideSingle as string).indexOf("|" + config.id + "." + x.step) < 0
      );
    });
  };
  const [remainingItems, setRemainingItems] = useState<
    OnScreenHelpConfigItem[]
  >(getItemsToShow(config?.items ?? []));

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        setCurrentStepIndex(currentStepIndex + 1);
        setRemainingItems([...remainingItems] as OnScreenHelpConfigItem[]);
      });
    });

    const observerConfig = { childList: true, subtree: true };
    const targetNode = document.body;

    observer.observe(targetNode, observerConfig);

    return () => {
      observer.disconnect();
    };
  }, []);

  const onClose = (items: OnScreenHelpConfigItem[]) => {
    const newRemainingItems = getItemsToShow(remainingItems);
    setRemainingItems(newRemainingItems);
  };

  const getStepToShow = (items: OnScreenHelpConfigItem[]) => {
    let step: number | undefined = undefined;
    for (let item of items) {
      // si verifica la presenza della classe
      const element = document.getElementsByClassName(item.className);
      if (element.length > 0) {
        step = item.step;
        break;
      }
    }
    return step;
  };
  // qui verifico se esiste un hints da mostrare
  const stepToShow = getStepToShow(getItemsToShow(remainingItems));
  if (!stepToShow) return <></>;

  const newConfig: OnScreenHelpConfig = { ...config };
  newConfig.id = config.id + "." + stepToShow;
  newConfig.items = config.items.filter((x) => x.step === stepToShow);

  // return OnScreenHelp with new config
  return (
    <OnScreenHelp
      config={newConfig}
      onClose={onClose}
      closeButtonLabel={
        getItemsToShow(remainingItems).length === 1 ? "common.close" : "common.next"
      }
    ></OnScreenHelp>
  );
};

export interface OnScreenHelpConfig {
  id: string;
  items: OnScreenHelpConfigItem[];
  arrowIcon: string; // Always looks up
  timeout?: number;
  buttonPosition?: string;
  buttonLocation?: number | string;
  showHideForGoodButton?: boolean;
}

export interface OnScreenHelpConfigItem {
  className: string;
  vertical: "top" | "bottom" | "center";
  horizontal: "left" | "center" | "right";
  width: number;
  height: number;
  text?: string;
  labelId?: string;
  padding?: number;
  arrowWidth?: number;
  arrowHeight?: number;
  disableScroll?: boolean;
  compact?: boolean;
  step?: number;
  isHTML?: boolean;
}

export const clearOnScreenHintSettings = () => {
  const cookies = new Cookies();
  cookies.remove(HIDE_ALL_COOKIE_NAME);
  cookies.remove(HIDE_COOKIE_NAME);
};

export default OnScreenHelp;
